import store from "../store";
import { getLS } from "../util/storage";

const languageOptions = [
  {
    name: "繁中",
    key: "zh-tw"
  },
  {
    name: "English",
    key: "en"
  }
];

const getJsonFiles = () => {
  // return require.context("../locales", true, /^\.\/(?:\w+\/)*\w+\/(?:[A-Za-z0-9_-]+)\.json$/i);
  return require.context("../locales", true, /[A-Za-z0-9-_,\s]+\.json$/i);
};

/** 取得 src/locales 的 json 語言包與語系 */
const getMessagesAndLanguages = () => {
  const messages = {};
  const languages = [];
  const jsonFiles = getJsonFiles();

  jsonFiles.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);

    if (matched && matched.length <= 1) return;
    const locale = matched[1];
    languages.push(locale);
    messages[locale] = {...messages[locale], ...jsonFiles(key)};
  });

  return [messages, languages];
};

/**
 * 優先權重：URL -> LS -> i18n
 * 1. 先看網頁有沒有 URL
 * 2. 如果沒有才看有沒有 Local Storage
 * 3. 都沒有才看 i18n
 */
const handleAppLanguage = to => {
  const queryLang = to.query.lang;
  const regex = /^(en|zh-tw)$/;
  const isMappingLang = lang => regex.test(lang);
  const isUrlQueryLang = isMappingLang(queryLang);
  const isLocalStorage =
    getLS("USER_LANGUAGE") === "en" || getLS("USER_LANGUAGE") === "zh-tw";
  const setLangAction = lang => store.dispatch("setLang", lang);

  switch (true) {
    case isUrlQueryLang:
      setLangAction(queryLang);
      break;
    case isLocalStorage:
      setLangAction(getLS("USER_LANGUAGE"));
      break;
    default:
      break;
  }
};

/** 更改 URL 的 Params */
const changeUrlSearchParams = (key, value) => {
  const queryParams = new URLSearchParams(window.location.search);
  // 如果原本沒有 queryParams 就不用處理
  if (queryParams.size === 0) return;
  queryParams.set(key, value);
  history.pushState(null, null, "?" + queryParams.toString());
};

export {
  languageOptions,
  changeUrlSearchParams,
  getMessagesAndLanguages,
  handleAppLanguage
};
